import { useNavigationGuard } from "@/utils/helper/navigation";
import React from "react";
import { Link, LinkProps, useLocation } from "react-router-dom";

interface GuardedLinkProps extends Omit<LinkProps, "onClick"> {
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onClickEffect?: any;
}

export const GuardedLink: React.FC<GuardedLinkProps> = ({ to, children, onClick, onClickEffect, ...props }) => {
  const handleNavigation = useNavigationGuard();
  const location = useLocation();

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Skip guard if linking to the same route
    const isSameRoute = location.pathname === to.toString();

    if (isSameRoute) {
      return;
    }
    if (onClickEffect) {
      onClickEffect();
    }

    try {
      // Call the original onClick if provided
      onClick?.(e);
      await handleNavigation(to.toString());
    } catch (error) {
      console.log("Navigation cancelled");
    }
  };

  return (
    <Link {...props} to={to} onClick={handleClick}>
      {children}
    </Link>
  );
};
